import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { ethers } from "ethers";
// import { ethers } from "ethers";

export const Injected = new InjectedConnector({
  supportedChainIds: [97],
});

// const rpc="de7757285d664cb6af8239c7fd98a7cc"

export const walletconnect = new WalletConnectConnector({
  rpc: {
    97: "https://mainnet.infura.io/v3/ec03b8dcd95348149519e0be7ac5098e",
  },
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
  pollingInterval: 12000,
});

const switchRequest = (chainId = 97) => {
  const { ethereum } = window as any;
  return ethereum.request({
    method: "wallet_switchEthereumChain",
    params: [{ chainId: ethers.utils.hexlify(97) }],
  });
};

export const switchNetwork = async () => {
  const { ethereum } = window as any;
  if (ethereum) {
    try {
      await switchRequest();
    } catch (error) {
      console.log(error);
    }
  }
};
